import React, { useEffect, useState, Fragment, useMemo } from 'react'
import Navbar from '../partials/Navbar';
import Sidebar from '../partials/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactTable from '@ashvin27/react-datatable';
import Select from "../partials/Select";
import Axios from 'axios';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import TrelloAddModal from '../partials/TrelloAddModal';
import EditListModal from '../partials/EditListModal';

const Integration = ({ auth }) => {

    const [records, setRecords] = useState([]);
	const [users, setUsers] = useState([])
	const [listData, setListData] = useState([])
	const [selectedUsers, setSelectedUsers] = useState([])
	const [board, setBoard] = useState()
	const [search, setSearch] = useState("")
	const [pageSize, setPageSize] = useState(20)

    const getBoards = () => {
		const email = localStorage.getItem("email")
		Axios
			.post(`/api/get-boards`, {email:email})
			.then(res => {
				
				setRecords(res?.data?.boards);
			})
			.catch(error => {
				console.error("Error fetching data:", error.message);
			});
	};

	const onChange = pageData => {
		setSearch(pageData?.filter_value)
		setPageSize(parseInt(pageData?.page_size))

	};

    const config = {
		page_size: pageSize,
		length_menu: [20, 30, 50],
		filename: "Boards",
		no_data_text: 'No task found!',
		button: {
			excel: true,
			print: true,
			csv: true,
		},
		language: {
			length_menu: "Show _MENU_ result per page",
		},
		show_length_menu: true,
		show_filter: true,
		show_pagination: true,
		show_info: true,
	};

	const editBoard = async(board) => {
		
		const email = localStorage.getItem("email")
		await Axios.post("/api/get-list-on-board", {boardId: board.boardId, email: email}).then((res)=> {
			setListData(res?.data?.lists)
			setBoard(board.boardId)
		})
	}

    const columns = useMemo(() => [
		{
			key: "name",
			text: "Board Name",
			className: "name",
			align: "left",
			sortable: true,
		},
		{
			key: "url",
			text: "Url",
			className: "url",
			align: "left",
			sortable: true,
		},
		{
			key: "_id",
			text: "Action",
			className: "_id",
			width: 100,
			align: "center",
			sortable: false,
			cell: record => { 
				return (
					<Fragment>
						<button
							data-toggle="modal" data-target="#edit-list-modal"
							className="btn btn-primary btn-sm"
							onClick={() => editBoard(record)}
							style={{marginRight: '5px'}}>
							<i className="fa fa-edit"></i>
						</button>
					</Fragment>
				);
			}
		}	  
	], [records]);

    useEffect(() => {
		getBoards();
	}, []);


    return (
		<div>
			<Navbar />
			<div className="d-flex" id="wrapper">
				<Sidebar />

				<div id="page-content-wrapper">
					<div className="container-fluid backdrop-cont">
                        <TrelloAddModal getData={getBoards}/>
                        <EditListModal listData={listData} board={board}/>
                        <button className="btn btn-primary float-right mt-3 mr-2" data-toggle="modal" data-target="#add-trello-modal"><FontAwesomeIcon icon={faPlus} /> Add Trello</button>

						<button className="btn btn-link mt-3" id="menu-toggle">
							<FontAwesomeIcon icon={faList} />
						</button>
						<h1 className="mt-2 text-primary">Trello Integrations</h1>

						<br />
						<div>
							{auth?.user?.role === 1 &&
								<div className="select_wrapper" >
									<label>Users: </label> {" "}
									<Select
										allOptions={users}
										selectedOptions={selectedUsers}
										setSelectedOptions={setSelectedUsers}
									/>
								</div>
							}

							
						</div>
						<br />

						<ReactTable
							config={config}
							records={records}
							columns={columns}
							onChange={onChange}
						/>
						
					</div>
				</div>
			</div>
		</div>
	);
}

export default Integration



// ATTA42748e9ebfe05c4df22d6d9c28b315727608119e55f346cf1765b8aeed5664f3D3BA27AF
// 358795588908d1a0ac6d96bb05797626